/**
 * A pale tint carrying its own ink, readable in both schemes, the way the Proving Ground's verdict pills are:
 * the 800 step on a light ground and the 200 step on a dark one, since `.main` or `.dark` as small text falls
 * under 4.5:1 on this theme. Written with `applyStyles` because the theme runs in CSS-variables mode, where
 * `palette.mode` is fixed at build time.
 */
export function tint(key: "primary" | "success" | "error" | "neutral", border = false) {
	return (theme: any) => {
		if (key === "neutral")
			return {
				color: "var(--mui-palette-text-secondary)",
				backgroundColor: "rgba(var(--mui-palette-common-onBackgroundChannel) / 0.06)",
				...theme.applyStyles("dark", { backgroundColor: "rgba(var(--mui-palette-common-onBackgroundChannel) / 0.1)" }),
			};
		const channel = `var(--mui-palette-${key}-mainChannel)`;
		return {
			color: `var(--mui-palette-${key}-800)`,
			backgroundColor: `rgba(${channel} / 0.1)`,
			...(border && { border: `1px solid rgba(${channel} / 0.28)` }),
			...theme.applyStyles("dark", {
				color: `var(--mui-palette-${key}-200)`,
				backgroundColor: `rgba(${channel} / 0.24)`,
				...(border && { borderColor: `rgba(${channel} / 0.5)` }),
			}),
		};
	};
}
